export default {
  SET_ENROLLABLE_FLOWS (state, flows) {
    state.enrollableFlows = flows
  },

  SET_ENROLLABLE_FLOWS_LOADING (state, isLoading) {
    state.isEnrollableFlowsLoading = isLoading
  }
}
